import { Text } from '@mantine/core';

import { useTranslation } from '@flecto/translations';
import { TextCurrency, type TextCurrencyProps } from '@flecto/ui';

import { useStoreDetails } from '../../hooks/useStoreDetails';

export type TextCurrencyStoreProps = TextCurrencyProps & {
  cents?: number
  labelVariant?: 'short' | 'full'
  labelFallback?: string
}

export function TextCurrencyStore({ cents, labelFallback, labelVariant = 'full', ...props }: TextCurrencyStoreProps) {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })
  const store = useStoreDetails()

  return store?.show_prices ? (
    <TextCurrency {...props} cents={cents} />
  ) : (
    <Text {...props}>
      {labelFallback ? labelFallback : labelVariant === 'short' ? t('text_price.label_short') : t('text_price.label_full')}
    </Text>
  )

}

